module.exports = __webpack_public_path__ + "static/media/failedillustration.b414e113.svg";